import { LibraryObject } from '@ansys/cloud-angular-client';
import {
  AWCTableCell,
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import { TableColumn } from '@ansys-internal/awf-angular/contributions';
import { AWFTableColumn } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';
import { ConceptService } from '../../../shared/services/concept.service';

@AWFTableColumn({
  id: ContributionsEnum.LIBRARY_TABLE_TYPE_COLUMN,
  priority: 350,
})
export class LibraryTypeColumn implements TableColumn {
  public id: string = ContributionsEnum.LIBRARY_TABLE_TYPE_COLUMN;
  public priority: number = 350;
  public header: string = 'Type';
  public type: TableCellTypes = TableCellTypes.TEXT;
  public align: TableCellAlign = TableCellAlign.LEFT;
  private typeMap: Map<string, string> = new Map([
    ['aero', 'Aero Configuration'],
    ['mass', 'Mass Configuration'],
    ['wheel', 'Wheel Configuration'],
    ['ancillary_load', 'Ancillary Load Configuration'],
    ['deceleration_limit', 'Deceleration Limit Configuration'],
    ['clutch', 'Clutch Component'],
    ['battery', 'Battery Component'],
    ['inverter', 'Inverter Component'],
    ['motor', 'Motor Component'],
    ['transmission', 'Transmission Component'],
    ['drive_cycle', 'Drive Cycle'],
    ['static_requirement', 'Static Requirement'],
    ['dynamic_requirement', 'Dynamic Requirement'],
  ]);

  constructor(private conceptService: ConceptService) {}

  public render(data: LibraryObject): Promise<AWCTableCell> {
    const meta = JSON.parse(data?.metadata ?? '{}');
    const type =
      this.conceptService.typeMap.get(meta?.type) ?? meta?.type ?? '';
    return Promise.resolve({
      value: this.typeMap.get(type) ?? 'Concept Resource',
    });
  }
}
